import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { updatePinUsuario } from '../action/updatePinUsuario';
import { ModalHelp } from './ModalHelp';
import { pinResendEmailValidation } from '../action/login2fa/pinResendEmailValidation';

interface ModalProps {
  isOpen: boolean;
  toggle: Function;
  token: string;
  values: any;
}

const initialState = {
  nombre: '',
  telefono: '',
  email: '',
  tiene_2fa: false,
  pendiente_2fa: false,
  password: '',
  confirmpassword: ''
}

export const ModalEditar: React.FC<ModalProps> = (props: ModalProps) => {
  const dispatch = useDispatch();
  const [editValues, setEditValues] = useState(initialState);
  const [isHelpOpen, setIsHelpOpen] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const { isOpen, toggle, token, values } = props;

  useEffect(() => {
    if (isOpen) {
      setEditValues(values);
    }
  }, [isOpen, values]);

  type ChangeHandler<T> = (name: string, value: T) => void;

  const onChange: ChangeHandler<any> = (name, value) => {
    setEditValues({
      ...editValues,
      [name]: value
    });
  };

  const updateData = (e: any) => {
    e.preventDefault();
    if (isValid()) {
      dispatch(UIActions.uiLoadActive());
      updatePinUsuario(token, editValues, dispatch);
      closeModal();
    }
  }

  const isValid = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!editValues.nombre || editValues.nombre.trim().length === 0) {
      Swal.fire('Advertencia', 'Nombre es requerido', 'warning');
      return false;
    } else if (!editValues.telefono || editValues.telefono.trim().length === 0) {
      Swal.fire('Advertencia', 'Teléfono es requerido', 'warning');
      return false;
    } else if (!editValues.email || editValues.email.trim().length === 0) {
      Swal.fire('Correo no valido', 'Ingresa un correo', 'warning');
      return false;
    } else if (!emailRegex.test(editValues.email)) {
      Swal.fire('Correo no valido', 'Ingresa un correo valido. Asegúrate de que el formato del correo electrónico sea correcto', 'warning');
      return false;
    } else if (editValues.password && editValues.password.trim().length < 8) {
      Swal.fire('Advertencia', 'La contraseña debe tener mínimo 8 caracteres', 'warning');
      return false;
    } else if ((editValues.password) && editValues.password !== editValues.confirmpassword) {
      Swal.fire('Advertencia', 'Las contraseña no coinciden', 'warning');
      return false;
    } else if ((editValues.password) && (!(/[a-z]/.test(editValues.password)) || !(/[A-Z]/.test(editValues.password)) || !(/[0-9]/.test(editValues.password)))) {
      Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        html:
          'La contraseña debe tener al menos: ' +
          (!(/[a-z]/.test(editValues.password)) ? '<li><b>Una minúscula</b></li> ' : '') +
          (!(/[A-Z]/.test(editValues.password)) ? '<li><b>Una mayúscula</b></li> ' : '') +
          (!(/[0-9]/.test(editValues.password)) ? '<li><b>Un número</b></li> ' : '')
      });
      return false;
    }
    return true;
  }

  const toggleHelp = () => {
    setIsHelpOpen(!isHelpOpen);
  };

  const reSendMail = () => {
    if (!isDisabled) {
      setIsDisabled(true);
      dispatch(pinResendEmailValidation(token, editValues));
    }
  }


  const closeModal = () => {
    toggle();
    setEditValues(initialState);
    setIsDisabled(false);
  }

  return (
    <>
      <Modal
        onHide={closeModal}
        show={isOpen}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton className='gradientBlue colorWhite'>
          <Modal.Title id="contained-modal-title-vcenter">
            Editar Pin Usuario
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className='p-2 bg-light'>
          <div className='d-flex flex-column'>
            <Form onSubmit={updateData}>
              <div>
                <Form.Label className='col-form-label'>Nombre*</Form.Label>
                <Form.Control
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  value={editValues.nombre}
                  id="nombre"
                  name="nombre"
                  type="text"
                  autoComplete='off'
                  maxLength={80}
                  placeholder="nombre">
                </Form.Control>
              </div>
              <div>
                <Form.Label className='col-form-label'>Teléfono*</Form.Label>
                <Form.Control
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  value={editValues.telefono}
                  id="telefono"
                  name="telefono"
                  autoComplete='off'
                  type="number"
                  maxLength={10}
                  placeholder="Teléfono"
                  onInput={(e: any) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(0, e.target.maxLength);
                  }}
                >
                </Form.Control>
              </div>
              <div>
                <Form.Label className='col-form-label'>Email*</Form.Label>
                <Form.Control
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  value={editValues.email}
                  id="email"
                  name="email"
                  autoComplete='off'
                  type="email"
                  maxLength={50}
                  placeholder="Ingresar email"
                >
                </Form.Control>
              </div>
              <hr />
              {
                (editValues.pendiente_2fa) ?
                  <div className='bg-warning text-dark px-1' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <small><i className="fas fa-shield-alt"></i>&nbsp; Pendiente de activar autenticación en dos fases (2FA)</small>

                    <button className='btn text-dark' type='button' onClick={() => toggleHelp()}>
                      <i className="far fa-question-circle"></i>
                    </button>
                  </div> :
                  <div className='bg-primary text-white px-1' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <small><i className="fas fa-shield-alt"></i>&nbsp; {editValues.tiene_2fa ? 'Desactivar' : 'Activar'} autenticación en dos fases (2FA)</small>
                    <button className='btn text-light' type='button' onClick={() => toggleHelp()}>
                      <i className="far fa-question-circle"></i>
                    </button>
                  </div>
              }
              <div className='d-flex flex-row justify-content-between'>

                <div className='d-flex flex-column justify-content-start'>
                  <Form.Label className='col-form-label'>Doble factor de autenticación (2FA):</Form.Label>
                  <Form.Check
                    checked={editValues.tiene_2fa}
                    className='justify-content-start'
                    type='checkbox'
                    id={`default`}
                    name='tiene_2fa'
                    disabled={editValues.pendiente_2fa}
                    onChange={(e) => onChange(e.target.name, e.target.checked)}
                  />
                </div>
                {editValues.pendiente_2fa &&
                  <div className=''>
                    <button type='button' className='btn btn-link' disabled={isDisabled} onClick={reSendMail}> <small>Reenviar correo de activación</small> </button>
                  </div>
                }
              </div>
              <div>
                <hr />
                <Form.Label className='col-form-label'>Cambiar contraseña</Form.Label>
                <Form.Control
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  id="password"
                  name="password"
                  autoComplete='off'
                  type="password"
                  maxLength={80}
                  placeholder="Contraseña mínimo 8 caracteres">
                </Form.Control>
              </div>
              <div>
                <Form.Label className='col-form-label'>Confirmar nueva contraseña</Form.Label>
                <Form.Control
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  id="confirmpassword"
                  name="confirmpassword"
                  autoComplete='off'
                  type="password"
                  maxLength={80}
                  placeholder="Confirmar nueva contraseña">
                </Form.Control>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className='bg-light'>
          <button onClick={() => closeModal()} className="btn btn-light btn-outline-secondary float-right">Cancelar</button>
          <button onClick={updateData} className="btn btn-primary float-right" type="submit">Guardar</button>
        </Modal.Footer>

      </Modal>
      <ModalHelp
        isOpen={isHelpOpen}
        toggle={toggleHelp}
      />
    </>
  )
}